// src/App.js
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";

/* Pages */
import LoginPage from "./components/LoginPage";
import RegularUserDashboard from "./components/RegularUserDashboard";
import CategoryManagementPage from "./components/CategoryManagementPage";
import ProductManagementPage from "./components/ProductManagementPage";
import UserManagementPage from "./components/UserManagementPage";
import SubmissionHistory from "./components/SubmissionHistory";
import SubmissionDetails from "./components/SubmissionDetails";
import PengirimanPage from "./components/PengirimanPage";
import ReportPage from "./components/ReportPage";

/* ✅ Produk Masuk pages */
import ProductIncomingManagementPage from "./components/ProductIncomingManagementPage";
import ProductIncomingInputPage from "./components/ProductIncomingInputPage";

/* ✅ NEW: Laporan Persediaan */
import InventoryReportPage from "./components/InventoryReportPage";

/* ✅ NEW: Change Password */
import ChangePasswordPage from "./components/pages/ChangePasswordPage"; // <-- sesuaikan path bila beda

/* === LOG pages === */
import LogBukuICVPage from "./components/pages/admin/log/LogBukuICVPage.jsx";
import LogStokVaksinasiPage from "./components/pages/admin/log/LogStokVaksinasiPage.jsx";

/* Guards */
import ProtectedRoute from "./routes/ProtectedRoute";
import RoleRoute from "./routes/RoleRoute";

/* Layouts */
import AdminLayout from "./components/layouts/AdminLayout";
import RegularLayout from "./components/layouts/RegularLayout";

/* Context */
import { CartProvider } from "./context/CartContext";

/**
 * Redirect dinamis sesuai role user:
 * - regular -> /regular
 * - admin   -> /admin/reports
 * - tidak ada -> /login
 */
function AuthHomeRedirect() {
  const role = localStorage.getItem("role");
  if (role === "regular") return <Navigate to="/regular" replace />;
  if (role === "admin") return <Navigate to="/admin/reports" replace />;
  return <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public */}
        <Route path="/login" element={<LoginPage />} />
        <Route index element={<AuthHomeRedirect />} />
        <Route path="/home" element={<AuthHomeRedirect />} />

        {/* Protected area */}
        <Route element={<ProtectedRoute />}>
          {/* ===== Regular area ===== */}
          <Route element={<RoleRoute roles={["regular"]} />}>
            <Route
              element={
                <CartProvider>
                  <RegularLayout />
                </CartProvider>
              }
            >
              <Route path="/regular" element={<RegularUserDashboard />} />

              {/* ✅ change password untuk regular */}
              <Route path="/change-password" element={<ChangePasswordPage />} />

              <Route
                path="/submissions"
                element={<SubmissionHistory userRole="regular" />}
              />
              <Route
                path="/submissions/:number"
                element={<SubmissionDetails userRole="regular" />}
              />
              <Route
                path="/pengiriman"
                element={<PengirimanPage userRole="regular" />}
              />
            </Route>
          </Route>

          {/* ===== Admin area ===== */}
          <Route element={<RoleRoute roles={["admin"]} />}>
            <Route element={<AdminLayout />}>
              {/* /admin diarahkan ke laporan */}
              <Route path="/admin" element={<Navigate to="/admin/reports" replace />} />

              {/* ✅ change password untuk admin */}
              <Route path="/admin/change-password" element={<ChangePasswordPage />} />

              <Route path="/admin/users" element={<UserManagementPage />} />
              <Route path="/admin/categories" element={<CategoryManagementPage />} />
              <Route path="/admin/products" element={<ProductManagementPage />} />

              {/* ✅ Produk Masuk */}
              <Route path="/admin/produk-masuk" element={<ProductIncomingManagementPage />} />
              <Route path="/admin/produk-masuk/input" element={<ProductIncomingInputPage />} />

              {/* ✅ NEW: Laporan Persediaan */}
              <Route path="/admin/laporan-persediaan" element={<InventoryReportPage />} />

              <Route
                path="/admin/submissions"
                element={<SubmissionHistory userRole="admin" />}
              />
              <Route
                path="/admin/submissions/:number"
                element={<SubmissionDetails userRole="admin" />}
              />
              <Route
                path="/admin/pengiriman"
                element={<PengirimanPage userRole="admin" />}
              />

              <Route path="/admin/reports" element={<ReportPage />} />

              {/* LOG routes */}
              <Route path="/admin/log/buku-icv" element={<LogBukuICVPage />} />
              <Route
                path="/admin/log/stok-vaksinasi"
                element={<LogStokVaksinasiPage />}
              />
            </Route>
          </Route>
        </Route>

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
